import { Input, Label } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function InputDemo() {
  return (
    <Section
      id="input"
      title="Input"
      description="Stock shadcn text input. For brand-flavored chat/search inputs, alias-import from @aisquare/pretty."
    >
      <VariantBlock label="Types">
        <div className="grid w-72 gap-3">
          <div className="grid gap-1.5">
            <Label htmlFor="in-text">Text</Label>
            <Input id="in-text" placeholder="Type something" />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="in-email">Email</Label>
            <Input id="in-email" type="email" placeholder="you@example.com" />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="in-password">Password</Label>
            <Input id="in-password" type="password" defaultValue="secret123" />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="in-number">Number</Label>
            <Input id="in-number" type="number" defaultValue={42} />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="in-file">File</Label>
            <Input id="in-file" type="file" />
          </div>
        </div>
      </VariantBlock>

      <VariantBlock label="States">
        <div className="grid w-72 gap-3">
          <Input placeholder="Default" />
          <Input placeholder="Disabled" disabled />
          <Input defaultValue="Has value" />
          <Input aria-invalid placeholder="aria-invalid" />
          <Input readOnly defaultValue="Read-only" />
        </div>
      </VariantBlock>
    </Section>
  );
}
